// Legal side of the account (docs/LEGAL.md): the operator notice, the acceptance of the terms, the copy of one's data
// and the deletion of the account. The server records everything; the browser only asks.
import { TERMS_VERSION, type LegalInfo, type PublicUser } from '@gruvetto/contracts';
import { api, currentUser, logout, updateUser } from './api.js';

let cache: Promise<LegalInfo> | null = null;
/** Who runs this server (legal notice, privacy policy); public, fetched once. */
export function legalInfo(): Promise<LegalInfo> {
  cache ??= api<LegalInfo>('/legal', { auth: false }).catch(e => { cache = null; throw e; });
  return cache;
}

/** The signed-in account has not accepted the current terms (Google or Strava sign-up, or terms that changed). */
export const needsConsent = (): boolean => { const u = currentUser(); return !!u && u.termsVersion !== TERMS_VERSION; };

/** Records the acceptance of the current terms on the account. */
export async function acceptTerms(): Promise<void> {
  updateUser(await api<PublicUser>('/me/consent', { method: 'POST', body: { version: TERMS_VERSION } }));
}

/** Everything the server holds about the player, as pretty JSON (portability). */
export async function exportMyData(): Promise<string> {
  return JSON.stringify(await api('/me/export'), null, 2);
}

/** Deletes the account on the server, then leaves the browser as a sign-out does (nothing of the account stays). */
export async function deleteMyAccount(): Promise<void> {
  await api('/me', { method: 'DELETE' });
  await logout();
}
